
import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { Breadcrumb, BreadcrumbList, BreadcrumbItem, BreadcrumbLink, BreadcrumbSeparator, BreadcrumbPage } from '@/components/ui/breadcrumb';
import { useCountry } from '@/contexts/country';

const InsightsHeader = () => {
  const navigate = useNavigate();
  const { countryCode, countryName } = useCountry();
  
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-2">
        <button 
          onClick={() => navigate('/')}
          className="flex items-center text-sm text-muted-foreground hover:text-foreground transition-colors"
        >
          <ChevronLeft size={16} className="mr-1" />
          Back to Home
        </button>
      </div>
      
      <Breadcrumb className="mb-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/">Home</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          {countryCode && (
            <>
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to={`/cards/${countryCode}`}>{countryName}</Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
            </>
          )}
          <BreadcrumbItem>
            <BreadcrumbPage>Insights</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      
      <h1 className="text-3xl font-bold mb-2">Insights</h1>
      <p className="text-muted-foreground">
        Discover key insights across various categories and topics
      </p>
    </div>
  );
};

export default InsightsHeader;
